import { render } from "./etDesignIndexPage.vue?vue&type=template&id=66118528"
import script from "./etDesignIndexPage.vue?vue&type=script&lang=js"
export * from "./etDesignIndexPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__